import templateUrl from "webforms/form-group.htm";

export default $parse => ({
  transclude: true,
  scope: true,
  link(scope, element, attr) {
    scope.mb = +(attr.mb || 0);
    scope.mt = +(attr.mt || 0);
    scope.colSplit = +(attr.colSplit || 0);
    scope.model = {
      type: attr.type || "text",
      attr,
      label: attr.label,
      required: attr.hasOwnProperty("ngRequired")
        ? scope.$eval(attr.ngRequired) !== false
        : attr.hasOwnProperty("required")
        ? scope.$eval(attr.required) !== false
        : false,
      disabled: attr.hasOwnProperty("ngDisabled")
        ? scope.$eval(attr.ngDisabled) !== false
        : attr.hasOwnProperty("disabled")
        ? scope.$eval(attr.disabled) !== false
        : false,
      readonly: attr.hasOwnProperty("ngReadonly")
        ? scope.$eval(attr.ngReadonly) !== false
        : attr.hasOwnProperty("readonly")
        ? scope.$eval(attr.readonly) !== false
        : false,
      placeholder: attr.placeholder,
      infoText: attr.infoText,
      updateOn: attr.updateOn || "default",
      errors() {
        return $parse(attr.errors)(scope);
      }
    };
    if ((scope.hasModel = !!attr.ngModel)) {
      var parsed = $parse(attr.ngModel);
      scope.model.value = function(newValue) {
        if (arguments.length) {
          parsed.assign(scope, newValue);
        }
        return parsed(scope);
      };
    }
    if ((scope.hasChange = !!attr.ngChange)) {
      var parsed = $parse(attr.ngChange);
    }
  },
  templateUrl
});
